module.exports = __webpack_public_path__ + "img/logo.ffc29646.png";